<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <article class="media">
                    <div class="media-content">
                        <div class="content">
                            <h3 class="title has-text-danger has-text-centered">DELETE THIS CAR?</h3>
                            <div class="has-text-centered">
                                <a class="button">close</a>
                                <a class="button is-danger" @click="deleteThisCar">DELETE</a>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
</template>

<script>
    export default {
        props: ['car'],
        computed: {
            isActive() {
                return this.$store.getters.getSingleCarDeleteModalStatus
            }
        },
        methods: {
            closeModal () {
                this.$store.dispatch('setSingleCarDeleteModalStatus', false)
            },
            deleteThisCar () {
                this.$store.dispatch('deleteSingleCarById', this.car.id)
                this.$router.push('/cars')
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Car/Details/DeleteCarModal.vue